const getSettings = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.settings;
};

const normalizeBaseUrl = (url: string): string =>
  url && url.endsWith('/') ? url : `${url}/`;

const settings = getSettings();

const API_REST_URL = normalizeBaseUrl(
  settings?.VITE_API_BASE_URL ?? import.meta.env.VITE_API_BASE_URL ?? '',
);

export { API_REST_URL };
